<br>
  <div>
    <span class="headerText">Notification Templates</span>
  </div>

  <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="templates" [paginator]="true" [rows]="30">
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [style.width]="col.width">
            {{col.header}}
            @if (col.header != '') {
              <p-sortIcon [field]="col.field"  ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-template
      let-columns="columns"
      let-rowIndex="rowIndex">
      <tr>
        <td><span class="p-column-title">{{columns[0].header}}</span>{{template.name}}</td>
        <td><span class="p-column-title">{{columns[1].header}}</span>{{template.subject}}</td>
        <td><span class="p-column-title">{{columns[2].header}}</span>{{template.title}}</td><td>
        <p-button
          
          type="button"
          icon="pi pi-pencil"
          (click)="editTemplate(template)"
          severity="info" >
        </p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
